import {useFetch} from "../useFetch";
import {Company} from "../../types/api/guide/company.types";
import {companyService} from "../../services/guide/company-service";

export const useFetchAllCompany = () => {
    const { isLoading, error, data, refetch } = useFetch<Company[]>(companyService.getAll);

    return { data: data || [], isLoading, error, refetch };
}